import useSWR from "swr";
import { defaultSWROption } from "@/services/api/api.service";
import { TagService } from "@/services/tag/tag.service";

export const useTags = (workspaceId: string) => {
  const key = ["tags", workspaceId];

  const fetcher = ([_, workspaceId]: [string, string]) => TagService.getTagsByWorkspaceId(workspaceId);

  const { data: tags, error, isLoading, mutate } = useSWR(
    workspaceId ? key : null,
    fetcher,
    defaultSWROption,
  );

  return {
    tags,
    error,
    isLoading,
    mutate,
  };
};
